export const ACCESS_LEVELS = {
  FULL_ACCESS: {
    canView: true,
    canEdit: true,
    canEditPriority: true,
    canEditEfforts: true,
    canAddComment: true,
    canAddRCA: true,
    canChangeStatus: true,
    canAssign: true,
    canUpdateHolidaysList: true,
    canUpdateBauList: true,
  },
  DEV_RCA_ONLY: {
    canView: true,
    canEdit: false,
    canEditPriority: false,
    canEditEfforts: false,
    canAddComment: true,
    canAddRCA: true,
    canChangeStatus: false,
    canAssign: false,
    canUpdateHolidaysList: false,
    canUpdateBauList: false,
  },
  COE_ACCESS: {
    canView: true,
    canEdit: false,
    canEditPriority: true,
    canEditEfforts: false,
    canAddComment: true,
    canAddRCA: false,
    canChangeStatus: false,
    canAssign: false,
    canUpdateHolidaysList: false,
    canUpdateBauList: false,
  },
  NO_ACCESS: {
    canView: false,
    canEdit: false,
    canEditPriority: false,
    canEditEfforts: false,
    canAddComment: false,
    canAddRCA: false,
    canChangeStatus: false,
    canAssign: false,
    canUpdateHolidaysList: false,
    canUpdateBauList: false,
  },
};

export const SEVERITY_OPTIONS = [
  { value: "P1", label: "P1" },
  { value: "P2", label: "P2" },
  { value: "P3", label: "P3" },
  { value: "P4", label: "P4" },
];

export const INCIDENT_STATUS_OPTIONS = [
  "New",
  "Work in progress",
  "Awaiting for users confirmation",
  "Awaiting for business inputs",
  "BAU team validation",
  "Resolve",
  "Closed",
  "Reopen",
  "Converted to CR",
  "On Hold",
  "Invalid",
];

export const ROLE_OPTIONS = [
  "Service Governance and Reporting Manager",
  "BAU Delivery Manager",
  "Frontend/API Developer",
  "Data Engineer",
  "Backend Developer",
  "Functional SME",
  "Data SME",
  "Business"
];

export const CR_STATUS_OPTIONS = [
  "New",
  "Awaiting for business inputs",
  "Work in progress",
  "Logic finalization",
  "Ready for development",
  "CDIO Validation",
  "COE Validation",
  "Ready for production",
  "Closed",
  "On Hold",
  "Invalid",
];

export const SLA_STATUS_OPTIONS = ["On Track", "Met", "Overdue", "Not Met"];

export const INVALID_REASONS = [
  "Duplicate Ticket",
  "Not a Defect",
  "Configuration Issue",
  "Business Request",
  "Already Resolved",
  "Insufficient Information",
  "Others",
];

export const summaryCategories = [
  { key: "Incident", title: "Incident" },
  { key: "Change Request", title: "Change request" },
  { key: "New development", title: "New developement" },
];

export const summaryStatuses = [
  { key: "Open", label: "Open" },
  { key: "In Progress", label: "Inprogress" },
  { key: "Closed", label: "Closed" },
];
